<template>
  <Modal v-model="groundingModal" class-name="distributorsStyle" :title="$t('key1003971')" width="1200"
    :transfer="false" :mask-closable="false" @on-visible-change="groundingModalChange">
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="550"
        :loading="tableLoading"
        :columns="groundingColumns"
        :data="groundingData">
      </Table>
    </div>
    <template #footer>
      <div style="text-align: center;">
        <Button @click="groundingModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" v-if="groundingData.length >0" @click="groundingBtn">{{ $t('key1000111') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getYmsWarehouseBlockList} from "@/utils/common";

export default {
  name: "groundingModal",
  mixins: [Mixin],
  props: {
    warehouseList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    let v = this;
    return {
      groundingModal: false,
      groundingColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return v.tableProductInformation(h, params);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328'),
          key: 'warehouseName',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return h('Select', {
              props: {
                value: v.groundingData[params.index].ymsWarehouseId,
                transfer: true
              },
              on: {
                'on-change'(e) {
                  v.groundingData[params.index].ymsWarehouseId = e;
                  v.groundingData[params.index].ymsWarehouseBlockId = null;
                  v.changeYmsWarehouse(e, params.index);
                }
              }
            }, v.warehouseList.map(i => {
              return h('Option', {
                props: {
                  value: i.ymsWarehouseId
                }
              }, i.name);
            }));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002329'),
          key: 'warehouseBlockName',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return h('Select', {
              props: {
                value: v.groundingData[params.index].ymsWarehouseBlockId,
                transfer: true
              },
              on: {
                'on-change'(e) {
                  v.groundingData[params.index].ymsWarehouseBlockId = e;
                  v.groundingData[params.index].ymsWarehouseLocationId = null;
                  v.changeYmsWarehouseBlock(e, params.index);
                }
              }
            }, v.groundingData[params.index].ymsWarehouseBlockList.map(i => {
              return h('Option', {
                props: {
                  value: i.ymsWarehouseBlockId
                }
              }, i.name);
            }));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002620'),
          key: 'warehouseLocalName',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return h('Select', {
              props: {
                value: v.groundingData[params.index].ymsWarehouseLocationId,
                transfer: true
              },
              on: {
                'on-change'(e) {
                  v.groundingData[params.index].ymsWarehouseLocationId = e;
                }
              }
            }, v.groundingData[params.index].ymsWarehouseLocationList.map(i => {
              return h('Option', {
                props: {
                  value: i.ymsWarehouseLocationId
                }
              }, i.code);
            }));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003962'),
          key: 'quantity',
          minWidth: 100,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003963'),
          key: 'availableBumber',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.availableBumber,
                min: 1,
                max: 9999999
              },
              style: {
                width: '110px'
              },
              on: {
                input: val => {
                  v.groundingData[params.index].availableBumber = val;
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 100,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000320'),
                    show: true,
                    clickFn: () => {
                      v.printCloudNoodle(params.row.availableBumber, params.row.ymsProductGoodsId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      groundingData: [],
      ymsPickupOrderId: null,
      supplierPickupOrderNumber: null,
    };
  },
  methods: {
    // 获取货品上架的详情信息
    getGroundingDetails(ymsPickupOrderId, supplierPickupOrderNumber) {
      let v = this;
      let ymsProductGoodsIds = [];
      v.optionBtnWidth = [];
      v.ymsPickupOrderId = ymsPickupOrderId;
      v.supplierPickupOrderNumber = supplierPickupOrderNumber;
      v.axios.put(api.put_ymsPickupOrder_goodsList + `?ymsPickupOrderId=${ymsPickupOrderId}&labelTypes=YMS, NONE`, null,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            data.map((item) => {
              item.availableBumber = null;
              item.ymsWarehouseId = null;
              item.ymsWarehouseBlockId = null;
              item.ymsWarehouseLocationId = null;
              item.ymsWarehouseBlockList = [];
              item.ymsWarehouseLocationList = [];
              ymsProductGoodsIds.push(item.ymsProductGoodsId);
            });
            if (ymsProductGoodsIds.length > 0) {
              (async () => {
                v.groundingData = await v.getProductInfoByIds(ymsProductGoodsIds, data);
                v.groundingModal = true;
              })();
            }
          }
        }
      });
    },
    // 货品上架的确定按钮
    groundingBtn() {
      let v = this;
      let query = {
        updateYmsInventoryBos: [],
        ymsPickupOrderId: v.ymsPickupOrderId,
        supplierPickupOrderNumber: v.supplierPickupOrderNumber
      };
      if (v.groundingData.length > 0) {
        for (let i = 0; i < v.groundingData.length; i++) {
          let item = v.groundingData[i];
          if (item.ymsWarehouseId === null) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003964'));
            return false;
          }
          if (item.ymsWarehouseBlockId === null) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003965'));
            return false;
          }
          if (item.ymsWarehouseLocationId === null) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003966'));
            return false;
          }
          if (item.availableBumber === null || item.availableBumber === '') {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003967'));
            return false;
          }
          let reg = v.$regular.positiveInteger;
          if (!reg.test(Number(item.availableBumber))) {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003968'));
            return false;
          }
          if (item.availableBumber > item.quantity) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003969'));
            return false;
          }
          query.updateYmsInventoryBos.push({
            availableNumber: item.availableBumber,
            ymsProductGoodsId: item.ymsProductGoodsId,
            ymsWarehouseLocationId: item.ymsWarehouseLocationId
          });
        }
      }
      v.axios.put(api.put_ymsPickupOrder_onShelves, query).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.groundingModal = false;
          v.$emit('updateData', true);
        }
      });
    },
    // 生成云卖面单
    printCloudNoodle(quantity, ymsProductGoodsId) {
      let v = this;
      if (quantity > 0) {
        let obj = {
          appendYmsExpressBillBos: [
            {
              quantity: quantity,
              ymsProductGoodsId: ymsProductGoodsId
            }
          ],
          type: 1
        };
        v.axios.post(api.post_productGoods_appendYmsExpressBill, JSON.stringify(obj), {loading: true}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.commonPrint(data, '1');
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003970'));
      }
    },

    // 选中仓库，获取对应的库区数据
    changeYmsWarehouse(value, index) {
      if (value) {
        this.groundingData[index].ymsWarehouseBlockList = [];
        this.groundingData[index].ymsWarehouseLocationList = [];
        getYmsWarehouseBlockList(value).then((ymsWarehouseBlockList) => {
          this.groundingData[index].ymsWarehouseBlockList = ymsWarehouseBlockList;
        });
      }
    },
    // 选中库区，获取对应库位数据
    changeYmsWarehouseBlock(value, index) {
      if (value) {
        this.groundingData[index].ymsWarehouseLocationList = [];
        this.axios.get(api.get_ymsWarehouseLocation_queryByYmsWarehouseBlockId + `?ymsWarehouseBlockId=${value}`).then(response => {
          if (response.data.code === 0) {
            this.groundingData[index].ymsWarehouseLocationList = response.data.datas;
          }
        });
      }
    },
    // 监听货品上架的弹窗
    groundingModalChange(value) {
      if (!value) {
        this.ymsPickupOrderId = null;
        this.supplierPickupOrderNumber = null;
        this.groundingData = [];
      }
    },
  }
};
</script>

<style scoped>

</style>